import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 2.414a2 2 0 0 0-1.422.594L14.446 6.14l-7.26 2.724-.004.002a2.01 2.01 0 0 0-1.268 1.54L3.016 27.821a1 1 0 0 0 1.148 1.165l17.438-2.9h.004a1.99 1.99 0 0 0 1.532-1.277l2.722-7.255 3.132-3.132a2 2 0 0 0 0-2.844l-8.57-8.57A2 2 0 0 0 19 2.414m6 13.172L27.586 13l-.006-.005L19 4.415l-.005.005L16.415 7zm-3.738 8.53-14.35 2.386 5.923-5.923a3.5 3.5 0 1 0-1.414-1.414l-5.922 5.922 2.387-14.343.002-.006.005-.003 6.855-2.572 9.09 9.089-2.574 6.86zM13 17.5a1.5 1.5 0 1 1 .509 1.126 1 1 0 0 0-.135-.135A1.5 1.5 0 0 1 13 17.5"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconSignatures = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSignatures);
export default Memo;
